module.exports = __webpack_public_path__ + "static/media/vii-alternate-ambientworks.9bca8d3.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/ambient-works/vii-alternate-ambientworks.mp3
// module id = nHID
// module chunks = 0